import { gql } from "@apollo/client"

export const GET_PARTICIPANT_PROFILE = gql`
  query ParticipantProfileBlocks($participant_id: ID!, $organization_id: ID) {
    participantProfile(
      participant_id: $participant_id
      organization_id: $organization_id
    ) {
      blocks {
        block_title
        block_name
        total_fields
        index
      }
    }
  }
`

export const GET_ENGAGED_SERVICES_BY_PARTICIPANT = gql`
  query EngagedServices($participant_id: ID!) {
    participantProfile: getSpecificBlockByParticipant(
      participant_id: $participant_id
      idBlock: "participant__engaged_services"
    ) {
      blocks {
        block_title
        block_name
        total_fields
        index
      }
    }
  }
`

export const PARTICIPANT_ACCOUNT_INFORMATION_BY_PARTICIPANT = gql`
  query EngagedServices($participant_id: ID!) {
    participantProfile: getSpecificBlockByParticipant(
      participant_id: $participant_id
      idBlock: "participant"
    ) {
      blocks {
        block_title
        block_name
        total_fields
        index
      }
    }
  }
`

export const GET_PARTICIPANT = gql`
  query GetParticipant($participant_id: ID!, $organization_id: ID!) {
    participant(
      participant_id: $participant_id
      organization_id: $organization_id
    ) {
      participant_id
      participant_alias
      participant_membership_id
      participant_name_first
      participant_name_last
      participant_name_preferred
      participant_phone_primary
      participant_email_account
      participant_email_secondary
      participant_phone_secondary
      participant_city_primary
      participant_state_primary
      participant_zip_code_primary
      participant_external_id
      participant_profile_image
      participant_membership_status
      program_list
      participant_last_engagement
      participant_last_activity
      id_participant_last_activity
      organization_id
      staff_full_name
      locations
    }
  }
`

export const PARTICIPANT_BLOCK = gql`
  query ParticipantBlock(
    $participant_id: ID!
    $idBlock: ID!
    $type: ID
    $organization_id: ID
    $enterprise_id: ID
  ) {
    block(
      idBlock: $idBlock
      type: $type
      organization_id: $organization_id
      enterprise_id: $enterprise_id
    ) {
      fields {
        idField
        field_type
        field_type_subtype
        field_description
        field_conditional
        field_label
        field_name
        field_visibility
        field_options {
          ...fieldOptions
          __typename
        }
        field_validation {
          ...fieldValidation
          __typename
        }
        multi_fields {
          ...multiField
          multi_fields {
            ...multiField
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    blockSaved(
      participant_id: $participant_id
      block_name: $idBlock
      organization_id: $organization_id
    ) {
      data
      __typename
    }
  }

  fragment fieldOptions on TypeFieldOptions {
    label
    value
    __typename
  }

  fragment fieldValidation on TypeFieldValidation {
    required
    min
    max
    maxlength
    file_extension
    file_size
    file_multi_files
    file_firestore_storage
    file_cloud_storage
    file_is_shared
    file_is_renameable
    __typename
  }

  fragment multiField on TypeMultiField {
    field_name
    field_type
    field_type_subtype
    field_label
    field_options {
      ...fieldOptions
      __typename
    }
    field_validation {
      ...fieldValidation
      __typename
    }
    __typename
  }
`

export const GET_ENTERPRISE_FIELD_DEFS = gql`
  query EnterpriseFieldDefs(
    $enterprise_id: ID
  ) {
    fieldDefs: fieldsByType(
      type: ["date", "time", "conditional_date", "conditional_time"]
      subtype: ["date", "time", "datetime"]
      enterprise_id: $enterprise_id
    ) {
      field_name
      field_type
      field_type_subtype
    }
  }
`
